export const lineStyleTypes=
{'dash':{img:`symbols-sls-dash.png`},
 "dash-dot":{img:`symbols-sls-dash-dot.png`}, 
 "dot":{img:`symbols-sls-dot.png`},
 "long-dash":{img:`symbols-sls-long-dash.png`},
 "long-dash-dot":{img:`symbols-sls-long-dash-dot.png`},
 "long-dash-dot-dot":{img:`symbols-sls-dash-dot-dot.png`},
 "none":{img:``},
 "short-dash":{img:`symbols-sls-short-dash.png`},
 "short-dash-dot":{img:`symbols-sls-short-dash-dot.png`},
 "short-dash-dot-dot":{img:`symbols-sls-short-dash-dot-dot.png`},
 "short-dot":{img:`symbols-sls-short-dot.png`},
 "solid":{img:`symbols-sls-solid.png`},
}

export const fillStyleTypes = {
  "backward-diagonal":{img:`symbols-sfs-backward-diagonal.png`},
  "cross":{img:`symbols-sfs-cross.png`},
  "diagonal-cross":{img:`symbols-sfs-diagonal-cross.png`},
  "forward-diagonal":{img:`symbols-sfs-forward-diagonal.png`},
  "horizontal":{img:`symbols-sfs-horizontal.png`},
  "solid":{img:`symbols-sfs-solid.png`},
  "vertical":{img:`symbols-sfs-vertical.png`},
  "none":{img:``},
}

export const fontWeights =  ["normal","bold"]
export const fontWeightBold =  ["bold"]
export const fontWeightNormal =  ["normal"]

export const fontStyles = ["normal", "italic"]
export const fontStyleNormal = ["normal"]
export const fontStyleItalic = ["italic"]

export const fontsAllStyle = [
  "Alegreya",
  "Alegreya SC",
  "Arial",
  "Avenir Next LT Pro",
  "BellTopo Sans",
  "Josefin Slab",
  "Merriweather",
  "Noto Sans",
  "Noto Serif",
  "Old Standard TT"
]

export const fontsNormalStyle = [
  "Amatic SC",
  "Avenir Next LT Pro Regular",
  "Cabin Sketch",
  "Josefin Sans",
  "Life Savers",
  "Orbitron",
  "Oswald",
  "Playfair Display",
  "Roboto",
  "Syncopate",
  "Ubuntu"
]

export const fontsBoldWeight = [
  "Amatic SC",
  "Life Savers",
  "Noto Serif"
]

export const fontsNormalWeight = [
  "Roboto"
]

export const fontsAllWeights = [
  "Alegreya",
  "Alegreya SC",
  "Arial",
  "Avenir Next LT Pro",
  "Avenir Next LT Pro Regular",
  "BellTopo Sans",
  "Cabin Sketch",
  "Josefin Sans",
  "Josefin Slab",
  "Merriweather",
  "Noto Sans",
  "Old Standard TT",
  "Orbitron",
  "Oswald",
  "Playfair Display",
  "Syncopate",
  "Ubuntu"
]


export const fontfamilies =  [
//   "Helvetica",
// "Garamond",
// "Futura",
// "Bodoni",
// "Arial",
// "Times New Roman",
// "Verdana",
// "Rockwell",
// "Franklin Gothic",
// "Univers",
// "Frutiger",
// "Avenir"
//****** */


  // "Abril Fatface",
"Alegreya",
"Alegreya SC",
// "Algerian",
// "Amarante",
"Amatic SC",
"Arial",
// "Atomic Age",
// "Audiowide",
"Avenir Next LT Pro",
// "Avenir Next LT Pro Demi",
"Avenir Next LT Pro Regular",
"BellTopo Sans",
// "Belleza",
// "Black Ops One",
"Cabin Sketch",
// "Coming Soon",
// "FGDC GeoAge",
// "Homemade Apple",
// "IM FELL DW Pica PRO",
"Josefin Sans",
"Josefin Slab",
// "Just Another Hand",
// "Kranky",
"Life Savers",
// "Loved by the King",
"Merriweather",
// "Montserrat",
"Noto Sans",
"Noto Serif",
"Old Standard TT",
"Orbitron",
// "Oregano",
"Oswald",
// "Pacifico",
// "Palatino Linotype",
"Playfair Display",
// "Redressed",
// "Risque",
"Roboto",
// "Rye",
// "Special Elite",
"Syncopate",
// "Tangerine",
"Ubuntu",
"UnifrakturCook",
// "Vast Shadow",
// "Walter Turncoat",
]

export const pointStyleTypes = {
  "circle":{img:`symbols-sms-circle.png`},
  "cross":{img:`symbols-sms-cross.png`},
  "diamond":{img:`symbols-sms-diamond.png`},
  "square":{img:`symbols-sms-square.png`},
  "triangle":{img:`symbols-sms-triangle.png`},
  "x":{img:`symbols-sms-x.png`},
}

export const clearDrawing=(view)=>{
    const drawgraphicsLayer = view.map.allLayers.find(layer => layer.id === "draw_graphiclyr")
    drawgraphicsLayer.removeAll();
  }

export const hexToRgbA = (hex, opac) => {
    var c;
    let arr = [];
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split("");
      if (c.length == 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = "0x" + c.join("");
      let colorcode =
        "rgba(" +
        [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
        "," +
        opac +
        ")";
      colorcode =
        "[" +
        [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
        "," +
        opac +
        "]";
      arr = [(c >> 16) & 255, (c >> 8) & 255, c & 255, Number(opac)];
      let reformatcolor = "rgba(" + arr.toString() + ")";
      return reformatcolor;
    }
  };